export const HOME = 'home';

export const MATERIALS = 'materials';

export const MIXTURES = 'mixtures';
